import { createSelector } from '@reduxjs/toolkit';

import { CategoryOpenMode } from '../../models/category/category';
import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';
import { DictionaryEntity, DictionaryType } from '../slices/dictionary';

const getDictionaryAll = (state: AppState) => state.dictionary.all;

export const getActiveDictionariesIds = createSelector(
  [getDictionaryAll],
  all =>
    Object.values(all)
      .filter(({ type }) => type === DictionaryType.CATEGORY)
      .map(({ id }) => id)
);

export const getDictionaryById = (
  state: AppState,
  id: UniqueId
): DictionaryEntity => getDictionaryAll(state)[id];

export const isDictionaryOpenForCategory = (
  state: AppState,
  id: UniqueId
): boolean => Boolean(getDictionaryById(state, id));

export const isDictionaryOpenedByCategoryName = createSelector(
  [
    (state: AppState) => state.category,
    getDictionaryAll,
    (_state: AppState, categoryName: string) => categoryName,
  ],
  (categoryState, dictionaryAll, categoryName) => {
    const categoryId = Object.values(categoryState).find(
      category =>
        category.category.source.category === categoryName &&
        category.openMode === CategoryOpenMode.DICTIONARY
    )?.category.id;

    return Boolean(categoryId && dictionaryAll[categoryId]);
  }
);
